interface SummarySectionProps {
  summary: string;
}

export default function SummarySection({ summary }: SummarySectionProps) {
  return (
    <section className="py-12">
      <div className="container">
        <h2 className="mb-4 text-3xl font-bold text-gray-900 dark:text-gray-50">Summary</h2>
        <p className="text-lg leading-relaxed text-gray-700 dark:text-gray-300">{summary}</p>
      </div>
    </section>
  );
}
